import { render, staticRenderFns } from "./burs.vue?vue&type=template&id=6d355a9e&"
import script from "./burs.vue?vue&type=script&lang=js&"
export * from "./burs.vue?vue&type=script&lang=js&"
import style0 from "./burs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports